module.exports = "/build/web/svg/social/linkedin.d176a77b87c98d905e92882aabafd092.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/linkedin.svg
// module id = 191
// module chunks = 24